import { render, staticRenderFns } from "./EmailPartTypeSwitcher.vue?vue&type=template&id=089bb1a8&lang=pug"
import script from "./EmailPartTypeSwitcher.vue?vue&type=script&lang=ts"
export * from "./EmailPartTypeSwitcher.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports